import Axios from 'axios';

interface Config {
    backendUrl: string;
    renderingUrl: string;
    eventBroadcasterUrl: string;
    clientFrontendUrl: string;
    storageUrl: string;
    chatUrl: string;
    facebookAppId: string;
}

export default new Promise<Config>(async (resolve, reject) => {
    try {
        const response = await Axios.get('/runtime-config.json');

        resolve(response.data);
    } catch (error) {
        reject(error);
    }
});
